//
//
//
//


export default {
	name: 'SearchFilterTagsItem',
	props: ["item"],
	methods: {
		deselect() {
			const data = {
				groupID: this.item.groupID,
				id: this.item.id,
				value: false
			};
			this.$emit("removefilter", data);
		}
	},
}
